import { resetRemoteVersion } from './remoteVersion';
import { resetDirtyKeys } from './dirtyKeys';

/**
 * Reset every module-global piece of session-sync state (AVS-4330). Entering a different session
 * invalidates both the version gate (versions are per session record) and the dirty set (in-flight
 * edits belong to the old session). Grouping the two resets in one call keeps every session-switch
 * entry point from wiring up only one of them.
 */
export function resetSessionSyncState(): void {
  resetRemoteVersion();
  resetDirtyKeys();
}
